import { render, staticRenderFns } from "./UnidadeOperacional.vue?vue&type=template&id=8835cd42&"
import script from "./UnidadeOperacional.vue?vue&type=script&lang=js&"
export * from "./UnidadeOperacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports